<template>
<div class="cx_stock_schedule_button">
  <!-- 棚卸対象外商品の場合は非活性 -->
  <b-button  @click="onFuncClicked"  tabindex="-1" :disabled="commodity.isNoStock || $api.perms.hasMenuPermission('stock.menu_stock_balance')==false">在庫&nbsp;<i class="material-symbols-outlined small valign"  style="pointer-events:none;">apps</i></b-button>
  <PopStockSchedule v-model="showPopover" :target="target" :commodity="commodity" :sku="sku" :segment ="segment" :stockDate="stockDate"/>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class BtnStockSchedule extends Vue {
  @Prop({ default: null }) public commodity: Common.Commodity;
  @Prop({ default: null }) public sku: Common.Commodity;  
  @Prop({ default: null }) public stockDate: Date; 
  @Prop({ default: null }) public segment: Common.Segment;  

  public showPopover :boolean = false;
  public target: HTMLElement = null;

  public onFuncClicked(event: Event){
    //targetとなるボタン
    this.target = event.srcElement as HTMLElement;

    if (this.showPopover) this.showPopover = false;
    else this.showPopover = true;

  }
}
</script>
<style lang="scss">
.cx_stock_schedule_button{
  width: 78px;
  button{
    padding: 1px 10px;
    font-size: 12px;
    display: flex;
    align-items: center;  
  }
}
</style>